import React from "react";
import cx from "classnames";

import styles from "./animated.module.scss";
import { polymorphic, classMapper } from "../utils";

const classMap = {
  animation: {
    "scale-fade-in": styles.animatedScaleFadeIn,
    "slide-down-in": styles.animatedSlideDownIn,
    "slide-up-in": styles.animatedSlideUpIn
  }
};

export namespace Animated {
  export type Props = {
    animation?: keyof typeof classMap["animation"];
    className?: string;
    delay?: number;
  };
}

export const Animated = polymorphic("div")<Animated.Props>(
  ({
    as: Component,
    animation = "scale-fade-in",
    children,
    className,
    delay,
    ...props
  }) => {
    const classList = cx(
      className,
      delay && styles[`animatedDelay${delay}` as keyof typeof styles],
      ...classMapper(classMap, {
        animation
      })
    );

    return (
      <Component {...props} className={classList}>
        {children}
      </Component>
    );
  }
);
